import { render } from "./RemoveButton.vue?vue&type=template&id=163fdd23"
import script from "./RemoveButton.vue?vue&type=script&lang=js"
export * from "./RemoveButton.vue?vue&type=script&lang=js"

import "./RemoveButton.vue?vue&type=style&index=0&id=163fdd23&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__